export const getAutostart = (autostart: boolean | undefined, search: string): boolean => {
	return autostart ?? new URLSearchParams(search).get('autostart') === 'true'
}
